const actionTypes = require('constants/actionTypes');
const { Promise } = require('es6-promise');
const get = require('lodash/object/get');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

function accountRetentionsOutdated() {
    return {
        type: actionTypes.ACCOUNT_RETENTIONS_OUTDATED
    };
}

function loginData(accountId) {
    return {
        type: actionTypes.FETCH_ACCOUNT_RETENTIONS_REQUEST,
        payload: {
            accountId
        }
    };
}

function requestAccountInfoSuccess(data, accountId) {
    return {
        type: actionTypes.FETCH_ACCOUNT_RETENTIONS_SUCCESS,
        payload: {
            accountId,
            nextPage: get(data, '_links.nextPage.href', ''),
            retentions: get(data, 'retenciones', [])
        }
    };
}

function requestAccountInfoFailure(data, accountId) {
    return {
        type: actionTypes.FETCH_ACCOUNT_RETENTIONS_FAILURE,
        payload: {
            accountId,
            data
        }
    };
}

function requestNextAccountRetentionsPageSuccess(data, accountId) {
    return {
        type: actionTypes.FETCH_NEXT_ACCOUNT_RETENTIONS_PAGE_SUCCESS,
        payload: {
            accountId,
            nextPage: get(data, '_links.nextPage.href', ''),
            retentions: get(data, 'retenciones', [])
        }
    };
}

function getAccountRetentions(dispatch, accountId, product, contractNumber) {
    dispatch(loginData(accountId));
    return new Promise(function() {
        const accountsRequestData = {
            query: {
                producto: product,
                numeroContrato: contractNumber
            }
        };
        APIGet(
            dispatch,
            apiURLBuilder.getURL('accountRetentions', { id: accountId }),
            accountsRequestData
        ).then(
            function(response) {
                dispatch(requestAccountInfoSuccess(response, accountId));
            },
            function(response) {
                dispatch(requestAccountInfoFailure(response, accountId));
            }
        );
    });
}

function getNextAccountRetentionsPage(dispatch, accountId, nextPageURL) {
    dispatch(loginData(accountId));
    return new Promise(function() {
        const accountsRequestData = {};
        APIGet(dispatch, nextPageURL, accountsRequestData).then(
            function(response) {
                dispatch(requestNextAccountRetentionsPageSuccess(response, accountId));
            },
            function(response) {
                dispatch(requestAccountInfoFailure(response, accountId));
            }
        );
    });
}

function requestAccountRetentions(accountId) {
    return function(dispatch, getState) {
        const immAccountRetentions = getState().accountsRetentions.get(accountId);
        if (!immAccountRetentions || immAccountRetentions.get('isOutdated') || !!immAccountRetentions.get('error')) {
            const immAccount = getState().accounts.get('byId').get(accountId);
            getAccountRetentions(dispatch, accountId, immAccount.get('product'), immAccount.get('contractNumber'));
        }
    }
}

function requestNextAccountRetentionsPage(accountId) {
    return function(dispatch, getState) {
        const nextPageURL = getState().accountsRetentions.get(accountId).get('nextPage');
        getNextAccountRetentionsPage(dispatch, accountId, nextPageURL);
    };
}

module.exports = {
  requestAccountRetentions,
  requestNextAccountRetentionsPage,
  accountRetentionsOutdated
}
